import React, { Component } from 'react';
import { Row, Col, Form, Input, Button, Modal, Icon } from 'antd';
import { api, app, config } from "../../app";
import PwdSet from "./PwdSet";

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPwd: false, //密码显示
            input_focus: 0, //输入框焦点
            sLoading: false,    //提交按钮加载
            modal_visible: false,    //密码设置
        };
    }

    setData = (data, cb) => {
        app.setState(this, data, cb);
    }

    componentDidMount() {
        this._isMounted = true;
        this.props.form.validateFields();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * 显示密码
     */
    handleShowPwd = () => {
        const showPwd = !this.state.showPwd;
        this.setData({ showPwd });
    };

    /**
     * 获取焦点改变颜色
     * @param input_focus
     */
    handleInputFocus = (input_focus) => {
        this.setData({ input_focus });
    };

    /**
     * 登录
     */
    handleLogin = (e) => {
        const _this = this;
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (err) {
                // console.error(err);
                return false;
            } else {
                if (this.state.sLoading) return false;
                this.setData({ sLoading: true }, async () => {
                    let { flag, data, msg } = await app.post(api.Login, values);
                    this.setData({ sLoading: false });
                    // console.log(data);
                    if (flag === 1) {
                        app.setToken(data.token);
                        app.setData('targetValue', '');
                        app.setData('indexno', data.indexno);
                        app.setData('account', values.account);
                        app.setData('is_admin', data.is_admin);
                        app.setData('teamposition_id', data.teamposition_id);
                        app.setData('mobile', data.mobile);
                        app.setData('information_audit', data.information_audit + '');

                        if (data.is_first === 1) {
                            sessionStorage.setItem('firstLoginData', JSON.stringify(data));
                            this.props.history.replace('/login/first');
                        } else {
                            app.setLoginInfo(data);
                            this.props.history.replace('/');
                        }
                    } else if (flag === 0) {
                        app.alert(msg, 'error', '60%');
                    } else if (flag === -1) {
                        app.alert('您还未设置密码!', 'info', '10%');
                        this.handleSetPwdOpen();
                    } else {
                        app.alert("网络服务忙~", 'error', '60%');
                        if (config.debug) console.error(msg);
                    }
                });
            }
        });
    };

    /**
     * 打开设置密码对话框
     * @param flag
     */
    handleSetPwdOpen = () => {
        this.setState({ modal_visible: true });
    }

    /**
     * 关闭置密码对话框
     * @param flag
     */
    handleSetPwdClose = (flag) => {
        this.setState({ modal_visible: false });
        if (flag) {
            this.props.form.setFieldsValue({ password: '' });
        }
    }

    render() {
        const { getFieldDecorator, getFieldsError } = this.props.form,
            modal_visible = this.state.modal_visible;
        return (
            <div className="l_content">
                <div style={{height:'50px'}}></div>
                <div className="lc_login">
                    <Row className="cl_top">
                        <Col style={{ height: "100%", background: "#00A0E8" }} span={6} />
                        <Col style={{ height: "100%", background: "#25589A" }} span={6} />
                        <Col style={{ height: "100%", background: "#E8A700" }} span={6} />
                        <Col style={{ height: "100%", background: "#4BB0B6" }} span={6} />
                    </Row>
                    <div className="cl_con">
                        <Row className="clc_title"><span>欢迎登录</span></Row>
                        <Form layout="inline" onSubmit={this.handleLogin}>
                            <FormItem validateStatus='' help='' className="login_form_item">
                                <Row type="flex" justify="center" align="middle"
                                    className={"clc_formItem " + (this.state.input_focus === 1 ? "clc_formItem_focus" : "")}>
                                    <Col span={4} className="cfi_icon"><i className="iconfont icon-Account_number"></i></Col>
                                    <Col span={20} className="cfi_input">
                                        {getFieldDecorator('account', {
                                            rules: [{
                                                required: true, message: ''
                                            }]
                                        })(
                                            <Input placeholder="身份证/手机号"
                                                onFocus={() => {
                                                    this.handleInputFocus(1)
                                                }}
                                            />
                                            // onInput={(e)=>{this.handleInput(e, 1)}}
                                        )}
                                    </Col>
                                </Row>
                            </FormItem>
                            <FormItem
                                validateStatus=''
                                help=''
                                className="login_form_item"
                            >
                                <Row type="flex" justify="center" align="middle"
                                    className={"clc_formItem " + (this.state.input_focus === 2 ? "clc_formItem_focus" : "")}>
                                    <Col span={4} className="cfi_icon">
                                        <i className="iconfont icon-password"></i>
                                    </Col>
                                    <Col span={16} className="cfi_input">
                                        {getFieldDecorator('password', {
                                            rules: [{
                                                required: true,
                                                message: '请输入您的密码'
                                            }, {
                                                min: 4,
                                                message: '请输入您的密码'
                                            }],
                                            // normalize: (value = "") => {
                                            //     let text = "";
                                            //     for (let v in value) {
                                            //         text += "*";
                                            //     }
                                            //     return text;
                                            // }
                                        })(
                                            <Input type={this.state.showPwd ? "text" : "password"}
                                                placeholder="密码"
                                                onFocus={() => {
                                                    this.handleInputFocus(2)
                                                }} />
                                            // onInput={(e)=>{this.handleInput(e, 2)}}
                                        )}
                                    </Col>
                                    <Col span={4} className="cfi_show" onClick={() => {
                                        this.handleShowPwd()
                                    }}><i
                                        className={"iconfont icon-See " + (this.state.showPwd ? "cfi_show_foucs" : "")}></i></Col>
                                </Row>
                            </FormItem>
                            <Button type="primary" htmlType="submit" disabled={hasErrors(getFieldsError())}
                                loading={this.state.sLoading}
                                className="lc_submit">
                                登录
                            </Button>
                        </Form>

                        <div style={{ width: '50vw', color: 'red', fontSize: 18, margin: '20px auto', paddingBottom: '20px' }}>
                            请联系队管录入队员信息后登录
                            {/*系统正在更新重要功能（与相关部门对接志愿服务时长累积及出具合法服务时长证明），系统将尽快恢复原有状态，不影响原有用户登陆上传信息*/}
                        </div>


                        <div className="tools">
                            <Button type="primary" size='small' onClick={this.handleSetPwdOpen} ghost>设置密码<Icon
                                type="setting" /></Button>
                        </div>
                        <Modal
                            visible={modal_visible}
                            title={<div style={{ textAlign: 'center' }}>设置您的登录密码</div>}
                            footer={null}
                            onCancel={this.handleSetPwdClose}
                            maskClosable={false}
                            style={{ top: "calc(calc(100% - 487px) / 2)" }}
                            destroyOnClose
                        >
                            <PwdSet onClose={this.handleSetPwdClose} />
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/routes/login/Index.jsx